import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class PublisherStore {
    version = '1.0';

    featuredPublishers = [];
    featuredSection = {};

    whatshotPublishers = [];
    popularNowPublishers = [];
    nearMePublishers = [];
    recommendedPublishers = [];

    masterDirectoryPublishers = [];   // full paginated list — used for search
    directoryPublishers = [];          // first 50 — what's shown by default
    directoryFilterIndustries = [];

    search = {
        whatshotEnabled: false,
        searchText: '',
        industryFilters: [],
    };

    observed = {};

    constructor() {
        makeObservable(this, { observed: observable });
        withActions(this, actions);
    }
}

export function usePublisherStore() {
    const { store } = useStores();
    return store.publisherStore;
}
